import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';
import { getRequestTraceHttpHeaders } from '@mitsubishi/shared/request-tracing';

import { ExportPerformanceFieldConfig } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ExportPerformanceService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/export-performance';
  }

  getConfigs(
    categoryCode: string,
    productTypeId: number,
    projectId: string
  ): Observable<ExportPerformanceFieldConfig[]> {
    const params = {
      category_code: categoryCode,
      productTypeId: productTypeId,
      projectId: projectId,
    };
    return this.http.get<ExportPerformanceFieldConfig[]>(`${this.baseUrl}/config`, { params });
  }

  saveStudyExportPerformance(
    projectId: string,
    studySubcategoryId: string,
    performanceId: string,
    unitId: string,
    body: any,
    requestTraceId?: string
  ): Observable<null> {
    const headers = getRequestTraceHttpHeaders(requestTraceId);
    return this.http.post<null>(
      `${this.baseUrl}/project/${projectId}/studySubcategoryId/${studySubcategoryId}/performance/${performanceId}/unitId/${unitId}/grid`,
      body,
      { headers }
    );
  }

  saveSelectionExportPerformance(
    projectId: string,
    unitId: string,
    body: any,
    requestTraceId?: string
  ): Observable<null> {
    const headers = getRequestTraceHttpHeaders(requestTraceId);
    return this.http.post<null>(`${this.baseUrl}/project/${projectId}/unitId/${unitId}/grid`, body, { headers });
  }
}
